import { SimulationObject } from '../../interfaces/simulation-object';
import { ResultConnector } from './connector/result-connector.model';
import { FlexibleFatigueGlobalProperties } from './fad-flex/flexible-fatigue-global-properties.model';
import { ResultInterval } from './result-interval.model';

export class LineResultsRequester implements SimulationObject {
  id?: number;
  internalId: number;
  title: string;
  lineId: number;
  lineTitle: string;
  intervals: ResultInterval[];
  connectors: ResultConnector[];
  flexibleFatigueGlobalProperties: FlexibleFatigueGlobalProperties;

  constructor() {}
}
